var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor google-drive-upload-file" }, [
    _c(
      "section",
      [
        _c("div", { staticClass: "title" }, [_vm._v("Channel ID")]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Google Drive Channel ID",
            "show-attributes": true,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.channelId,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "channelId", $$v)
            },
            expression: "clone.channelId",
          },
        }),
        _vm._v(" "),
        _c("small", [_vm._v("Dosyanın yükleneceği Google Drive kanal ID'si")]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      [
        _c("div", { staticClass: "title" }, [_vm._v("Asset ID")]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Supsis Asset ID",
            "show-attributes": true,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.assetId,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "assetId", $$v)
            },
            expression: "clone.assetId",
          },
        }),
        _vm._v(" "),
        _c("small", [_vm._v("Yüklenecek dosyanın Supsis Asset ID'si")]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      [
        _c("div", { staticClass: "title" }, [_vm._v("Folder ID (Opsiyonel)")]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Google Drive Folder ID",
            "show-attributes": true,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.folderId,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "folderId", $$v)
            },
            expression: "clone.folderId",
          },
        }),
        _vm._v(" "),
        _c("small", [
          _vm._v(
            "Dosyanın yükleneceği klasör ID'si (boş bırakılırsa root'a yüklenir)"
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      [
        _c("div", { staticClass: "title" }, [_vm._v("Dosya Adı (Opsiyonel)")]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Yeni dosya adı",
            "show-attributes": true,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.fileName,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "fileName", $$v)
            },
            expression: "clone.fileName",
          },
        }),
        _vm._v(" "),
        _c("small", [
          _vm._v(
            "Dosya için özel bir ad (boş bırakılırsa orijinal ad kullanılır)"
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }